import { PATH_DELIMITER, SEMESTER_ENROLMENT_MANAGEMENT } from '../../../constant/Constant';
import { createAction, handleActions } from 'redux-actions';
import { request } from '../../ApiModule';
import { put, takeEvery, call } from 'redux-saga/effects';
import NullCheckUtil from '../../../util/NullCheckUtil';

const ACTION_SEARCH = SEMESTER_ENROLMENT_MANAGEMENT + PATH_DELIMITER + 'ACTION_SEARCH';
const HANDLE_SEMESTER_INFO = SEMESTER_ENROLMENT_MANAGEMENT + PATH_DELIMITER + 'HANDLE_SEMESTER_INFO';
const HANDLE_SEMESTER_ID = SEMESTER_ENROLMENT_MANAGEMENT + PATH_DELIMITER + 'HANDLE_SEMESTER_ID';
const ACTION_SAVE_TERM = SEMESTER_ENROLMENT_MANAGEMENT + PATH_DELIMITER + 'ACTION_SAVE_TERM';
const ACTION_SAVE_NOTICE = SEMESTER_ENROLMENT_MANAGEMENT + PATH_DELIMITER + 'ACTION_SAVE_NOTICE';

export const actionSearch = createAction(ACTION_SEARCH);
export const actionSaveTerm = createAction(ACTION_SAVE_TERM);
export const actionSaveNotice = createAction(ACTION_SAVE_NOTICE);
export const handleSemesterId = createAction(HANDLE_SEMESTER_ID);

export function* semesterEnrolmentManagementSagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_SAVE_TERM, actionSaveTermSaga);
    yield takeEvery(ACTION_SAVE_NOTICE, actionSaveNoticeSaga);
}

function* actionSearchSaga({ payload: { params } }) {
    const result = yield call(request, {
        method: 'get',
        url: `/api/semester-university/semesters/${params.semesterId}/universities/${params.mainUniversityCd}/enrolment-info`,
        params,
    });

    if (result != undefined) {
        yield put({
            type: HANDLE_SEMESTER_INFO,
            payload: result,
        });

        console.log(params);
    }
}

function* actionSaveTermSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'post',
        url: '/api/semester-university/enrolment-term',
        data: params,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        console.log(callback);
        callback && callback();
    }
}

function* actionSaveNoticeSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'post',
        url: '/api/semester-university/enrolment-notice',
        data: params,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        console.log(callback);
        callback && callback();
    }
}

const initialState = {
    semesterInfo: null,
    semesterId: null,
};

const module = handleActions(
    {
        [HANDLE_SEMESTER_INFO]: (state, { payload: semesterInfo }) => ({ ...state, semesterInfo }),
        [HANDLE_SEMESTER_ID]: (state, { payload: semesterId }) => ({ ...state, semesterId }),
    },
    initialState,
);

export default module;
